(function () {
  if (typeof MyOffers === "undefined") {
    console.error("MyOffers not defined");
    return;
  }

  const modal = document.getElementById("deleteModal");
  const cancelBtn = document.getElementById("cancelDelete");
  const confirmBtn = document.getElementById("confirmDelete");
  const titleEl = document.getElementById("deleteModalTitle");

  if (!modal || !cancelBtn || !confirmBtn) return;

  let pendingUniqueKey = null;
  let pendingRow = null;

  function openModal(uniqueKey, rowEl) {
    pendingUniqueKey = uniqueKey;
    pendingRow = rowEl;

    if (titleEl) {
      titleEl.textContent = `Angebot ${uniqueKey} löschen`;
    }
    modal.classList.remove("hidden");
    modal.classList.add("flex");
    confirmBtn.focus();
  }

  function closeModal() {
    modal.classList.add("hidden");
    modal.classList.remove("flex");
    if (titleEl) titleEl.textContent = "Angebot löschen";
    pendingUniqueKey = null;
    pendingRow = null;
  }

  document.addEventListener("click", (e) => {
    const link = e.target.closest(".js-delete-offer");
    if (!link) return;

    e.preventDefault();

    const uniqueKey = link.dataset.uniqueKey;
    if (!uniqueKey) return;

    const row = link.closest(".offer-row");
    openModal(uniqueKey, row);
  });

  cancelBtn.addEventListener("click", closeModal);

  modal.addEventListener("click", (e) => {
    if (e.target === modal) closeModal();
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !modal.classList.contains("hidden")) {
      closeModal();
    }
  });

  confirmBtn.addEventListener("click", async () => {
    if (!pendingUniqueKey) return;

    confirmBtn.disabled = true;
    const oldText = confirmBtn.textContent;
    confirmBtn.textContent = "Lösche…";

    try {
      const form = new URLSearchParams();
      form.set("action", "delete_offer");
      form.set("unique_key", pendingUniqueKey);
      form.set("nonce", MyOffers.nonce);

      const res = await fetch(MyOffers.ajax_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        body: form.toString(),
        credentials: "same-origin",
      });

      const json = await res.json();

      if (!json?.success) {
        alert(json?.data?.message || "Löschen fehlgeschlagen.");
        return;
      }

      if (pendingRow) pendingRow.remove();
      closeModal();
    } catch (err) {
      alert("Netzwerkfehler. Bitte erneut versuchen.");
    } finally {
      confirmBtn.disabled = false;
      confirmBtn.textContent = oldText;
    }
  });
})();
